module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-assets', [_c('img', {
    attrs: {
      "id": "logo-end-message",
      "src": require("assets/logo/logo-white.png")
    }
  }), _vm._v(" "), _c('a-asset-item', {
    attrs: {
      "id": "frame-obj",
      "src": "static/models/frame.obj"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c36743a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Assets.vue
// module id = 183
// module chunks = 2